module.exports = __webpack_public_path__ + "static/img/s40.697ef3d3.png";